import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-traffic-light-mini',
    imports: [],
    templateUrl: './traffic-light-mini.component.html',
    styleUrl: './traffic-light-mini.component.scss'
})
export class TrafficLightMiniComponent {
  @Input() innerCircleColor = 'black';
  @Input() outerCircleColor = 'white';

  constructor() {

  }




}
